import React from 'react';

const LoadMore = ({display, onUpdate}) => (
  display ?
    <button className="button background__blue" onClick={() => onUpdate()}>Load more</button>
    :
    <button className="button button__disabled background__mist">Load more</button>
);

export default LoadMore;
